/**
 * List-response helpers shared by the EthisysCore monolith and plugins.
 *
 * List-returning tools (MCP tools, REST endpoints) return their rows either as a
 * bare array or wrapped in an `{ items }` / `{ rows }` envelope. {@link unwrapList}
 * normalises either shape to a flat array so callers never branch on it.
 */

/** A list response: a bare array or an `{ items }` / `{ rows }` envelope. */
export type ListEnvelope<T> = T[] | { items?: T[]; rows?: T[] };

/** Normalise a list response (bare array or `{ items }` / `{ rows }`) to a flat array. */
export function unwrapList<T>(response: ListEnvelope<T> | null | undefined): T[] {
  if (response == null) {
    return [];
  }
  if (Array.isArray(response)) {
    return response;
  }
  return response.items ?? response.rows ?? [];
}
